import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SAVE_GRAPH_PROMPT_FROM_CHAT_API } from '../../constants/central-api';

export default async function save_graph_prompt_from_chat_api_call(
  conversationId: string,
  responseId: string
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: SAVE_GRAPH_PROMPT_FROM_CHAT_API(shopSlug),
      method: 'POST',
      body: JSON.stringify({
        conversation_id: conversationId,
        response_id: responseId,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'SAVE_GRAPH_FROM_CHAT';
    const customMsg = 'Graph generating prompt saved from chat successfully';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return { success: true, data: response.data || null, message: null };
    } else {
      return {
        success: false,
        error: response?.message || 'Failed to save graph prompt',
        message: response?.message || null,
      };
    }
  } catch (exception) {
    console.log('Error during save graph from chat request');
    return {
      success: false,
      error: 'exception',
      message: 'An error occurred while saving the graph prompt',
    };
  }
}
